import React from "react";
import { Badge } from "@/components/ui/badge";
import { WO_STATUS_META, getWoStatusBadgeClass } from "@/config/constants";

/**
 * Unified status badge for Work Orders (OS).
 * Uses colors per PRD Módulo 02:
 * - Nova = Verde, Aceita = Amarelo, Em Atendimento = Laranja,
 * - Finalizada = Azul, Cancelada = Vermelho.
 */
export function WoStatusBadge({ value, size = "sm", withDot = false, className = "" }) {
    const meta = WO_STATUS_META[value];
    const badgeCls = getWoStatusBadgeClass(value);
    const sizeCls = size === "lg" ? "text-sm px-2.5 py-0.5" : "text-[11px] px-2 py-0.5";
    return (
        <Badge
            variant="outline"
            className={`gap-1.5 font-medium ${sizeCls} ${badgeCls} ${className}`}
            data-testid={`wo-status-badge-${value}`}
        >
            {withDot && (
                <span
                    className={`inline-block h-1.5 w-1.5 rounded-full ${meta?.dotClass || "bg-muted-foreground"}`}
                    aria-hidden="true"
                />
            )}
            {meta?.label || value}
        </Badge>
    );
}

export default WoStatusBadge;
